export default function createEditProductButton() {
    var editButton = document.createElement("button");
    editButton.innerHTML = "Editar";
    editButton.classList.add("button-link");
    editButton.name = "edit-product-button";
    return editButton;
}
